import ai_img from 'assets/csdd_images/ai__procurement_img.png';
import women_in_procurement_img from 'assets/csdd_images/women_in_supply_chain_img.png';
import procurement_eco from 'assets/csdd_images/procurement_ecosystem.jpg';
import procurement_influence from 'assets/csdd_images/procurement_influence.jpg';

const data = [
  {
    headerImage: procurement_eco,
    title: `Procurement Ecosystem: Challenges & Strategies`,
    href: 'https://procurementmag.com/articles/procurement-ecosystem-challenges-strategie',
  },
  {
    headerImage: procurement_influence,
    title: `CIPS: Procurement and Supply Chain Influence Ever Increasing`,
    href: 'https://procurementmag.com/procurement-strategy/cips-procurement-and-supply-chain-influence-ever-increasing',
  },
  {
    headerImage: ai_img,
    title: `The Complete Guide to AI in Procurement`,
    href: 'https://tipalti.com/procurement-hub/artificial-intelligence-in-procurement/',
  },
  {
    headerImage: women_in_procurement_img,
    title: `Women Leading Innovation in Africa's Supply Chains '2022'`,
    href: 'https://supplychainafrica.org/30-leading-women-in-the-african-supply-chain-industry/',
  },
];

export default data;
